module.exports = __webpack_public_path__ + "static/media/thank_you.29901605.png";